import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        listInfo:[],
        totalCount:0,
        auditList:[],
        auditTotal:0,
    },
    mutations: {
        setListInfo(state,payload){
            state.listInfo = payload;
        },
        setTotalCount(state,payload){
            state.totalCount = payload;
        },
        setAuditList(state,payload){
            state.auditList = payload;
        },
        setAuditTotal(state,payload){
            state.auditTotal = payload;
        },
    },
    actions: {
        queryLists({commit},data) {
            api.list(data).then(response =>{
                commit('setTotalCount',response.data.totalCount);
                commit('setListInfo',response.data.list);
            })
        },
        queryAuditList({commit},data){
            api.auditList(data).then(response =>{
                commit('setAuditTotal',response.data.totalCount);
                let list = response.data.list;
                if (data.status || data.status === '') {
                    commit('setAuditList',list);
                }else {
                    let newList = [];
                    if (data.showFalse){
                        for(let index in list) {
                            if (list[index].refuseExplain){
                                newList.push(list[index]);
                            }
                        }
                    }else {
                        for(let index in list) {
                            if (!list[index].refuseExplain){
                                newList.push(list[index]);
                            }
                        }
                    }
                    commit('setAuditList',newList);
                }
            })
        },
    }
}

appStore.registerModule('contractActivity', store);